"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseTermsApi = exports.PromiseSnsLinkagesApi = exports.PromiseRevenuesApi = exports.PromisePayeesApi = exports.PromiseMembersApi = exports.PromiseLiveStreamingServicesApi = exports.PromiseEntryValidApi = exports.PromiseEntryApi = exports.PromiseEntriesScoutApi = exports.PromiseCreatorsApi = exports.PromiseCreatorAppearInAdSurveyApi = exports.PromiseBusinessInvoiceApi = exports.PromiseAuthApi = void 0;
var ObservableAPI_1 = require("./ObservableAPI");
var PromiseAuthApi = (function () {
    function PromiseAuthApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_1.ObservableAuthApi(configuration, requestFactory, responseProcessor);
    }
    PromiseAuthApi.prototype.debugLoginAuth = function (_options) {
        var result = this.api.debugLoginAuth(_options);
        return result.toPromise();
    };
    PromiseAuthApi.prototype.deleteAuth = function (_options) {
        var result = this.api.deleteAuth(_options);
        return result.toPromise();
    };
    PromiseAuthApi.prototype.getAuth = function (_options) {
        var result = this.api.getAuth(_options);
        return result.toPromise();
    };
    PromiseAuthApi.prototype.signInAuth = function (inlineObject6, _options) {
        var result = this.api.signInAuth(inlineObject6, _options);
        return result.toPromise();
    };
    return PromiseAuthApi;
}());
exports.PromiseAuthApi = PromiseAuthApi;
var ObservableAPI_2 = require("./ObservableAPI");
var PromiseBusinessInvoiceApi = (function () {
    function PromiseBusinessInvoiceApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_2.ObservableBusinessInvoiceApi(configuration, requestFactory, responseProcessor);
    }
    PromiseBusinessInvoiceApi.prototype.getBusinessInvoice = function (_options) {
        var result = this.api.getBusinessInvoice(_options);
        return result.toPromise();
    };
    PromiseBusinessInvoiceApi.prototype.updateBusinessInvoice = function (inlineObject2, _options) {
        var result = this.api.updateBusinessInvoice(inlineObject2, _options);
        return result.toPromise();
    };
    return PromiseBusinessInvoiceApi;
}());
exports.PromiseBusinessInvoiceApi = PromiseBusinessInvoiceApi;
var ObservableAPI_3 = require("./ObservableAPI");
var PromiseCreatorAppearInAdSurveyApi = (function () {
    function PromiseCreatorAppearInAdSurveyApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_3.ObservableCreatorAppearInAdSurveyApi(configuration, requestFactory, responseProcessor);
    }
    PromiseCreatorAppearInAdSurveyApi.prototype.getCreatorAppearInAdSurvey = function (_options) {
        var result = this.api.getCreatorAppearInAdSurvey(_options);
        return result.toPromise();
    };
    PromiseCreatorAppearInAdSurveyApi.prototype.patchCreatorAppearInAdSurvey = function (inlineResponse2002, _options) {
        var result = this.api.patchCreatorAppearInAdSurvey(inlineResponse2002, _options);
        return result.toPromise();
    };
    return PromiseCreatorAppearInAdSurveyApi;
}());
exports.PromiseCreatorAppearInAdSurveyApi = PromiseCreatorAppearInAdSurveyApi;
var ObservableAPI_4 = require("./ObservableAPI");
var PromiseCreatorsApi = (function () {
    function PromiseCreatorsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_4.ObservableCreatorsApi(configuration, requestFactory, responseProcessor);
    }
    PromiseCreatorsApi.prototype.getCreators = function (_options) {
        var result = this.api.getCreators(_options);
        return result.toPromise();
    };
    PromiseCreatorsApi.prototype.patchCreators = function (inlineObject, _options) {
        var result = this.api.patchCreators(inlineObject, _options);
        return result.toPromise();
    };
    return PromiseCreatorsApi;
}());
exports.PromiseCreatorsApi = PromiseCreatorsApi;
var ObservableAPI_5 = require("./ObservableAPI");
var PromiseEntriesScoutApi = (function () {
    function PromiseEntriesScoutApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_5.ObservableEntriesScoutApi(configuration, requestFactory, responseProcessor);
    }
    PromiseEntriesScoutApi.prototype.putEntry = function (hash, inlineObject4, _options) {
        var result = this.api.putEntry(hash, inlineObject4, _options);
        return result.toPromise();
    };
    return PromiseEntriesScoutApi;
}());
exports.PromiseEntriesScoutApi = PromiseEntriesScoutApi;
var ObservableAPI_6 = require("./ObservableAPI");
var PromiseEntryApi = (function () {
    function PromiseEntryApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_6.ObservableEntryApi(configuration, requestFactory, responseProcessor);
    }
    PromiseEntryApi.prototype.postEntry = function (inlineObject3, _options) {
        var result = this.api.postEntry(inlineObject3, _options);
        return result.toPromise();
    };
    PromiseEntryApi.prototype.postLiveStreamingEntry = function (inlineObject5, _options) {
        var result = this.api.postLiveStreamingEntry(inlineObject5, _options);
        return result.toPromise();
    };
    return PromiseEntryApi;
}());
exports.PromiseEntryApi = PromiseEntryApi;
var ObservableAPI_7 = require("./ObservableAPI");
var PromiseEntryValidApi = (function () {
    function PromiseEntryValidApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_7.ObservableEntryValidApi(configuration, requestFactory, responseProcessor);
    }
    PromiseEntryValidApi.prototype.getEntryValid = function (entryType, googleEmail, _options) {
        var result = this.api.getEntryValid(entryType, googleEmail, _options);
        return result.toPromise();
    };
    return PromiseEntryValidApi;
}());
exports.PromiseEntryValidApi = PromiseEntryValidApi;
var ObservableAPI_8 = require("./ObservableAPI");
var PromiseLiveStreamingServicesApi = (function () {
    function PromiseLiveStreamingServicesApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_8.ObservableLiveStreamingServicesApi(configuration, requestFactory, responseProcessor);
    }
    PromiseLiveStreamingServicesApi.prototype.getLiveStreamingServices = function (_options) {
        var result = this.api.getLiveStreamingServices(_options);
        return result.toPromise();
    };
    return PromiseLiveStreamingServicesApi;
}());
exports.PromiseLiveStreamingServicesApi = PromiseLiveStreamingServicesApi;
var ObservableAPI_9 = require("./ObservableAPI");
var PromiseMembersApi = (function () {
    function PromiseMembersApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_9.ObservableMembersApi(configuration, requestFactory, responseProcessor);
    }
    PromiseMembersApi.prototype.disableMembers = function (id, _options) {
        var result = this.api.disableMembers(id, _options);
        return result.toPromise();
    };
    PromiseMembersApi.prototype.getMembers = function (_options) {
        var result = this.api.getMembers(_options);
        return result.toPromise();
    };
    PromiseMembersApi.prototype.inviteMembers = function (_options) {
        var result = this.api.inviteMembers(_options);
        return result.toPromise();
    };
    PromiseMembersApi.prototype.updateMembers = function (id, _options) {
        var result = this.api.updateMembers(id, _options);
        return result.toPromise();
    };
    return PromiseMembersApi;
}());
exports.PromiseMembersApi = PromiseMembersApi;
var ObservableAPI_10 = require("./ObservableAPI");
var PromisePayeesApi = (function () {
    function PromisePayeesApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_10.ObservablePayeesApi(configuration, requestFactory, responseProcessor);
    }
    PromisePayeesApi.prototype.getPayee = function (_options) {
        var result = this.api.getPayee(_options);
        return result.toPromise();
    };
    PromisePayeesApi.prototype.updatePayee = function (inlineObject1, _options) {
        var result = this.api.updatePayee(inlineObject1, _options);
        return result.toPromise();
    };
    return PromisePayeesApi;
}());
exports.PromisePayeesApi = PromisePayeesApi;
var ObservableAPI_11 = require("./ObservableAPI");
var PromiseRevenuesApi = (function () {
    function PromiseRevenuesApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_11.ObservableRevenuesApi(configuration, requestFactory, responseProcessor);
    }
    PromiseRevenuesApi.prototype.ableToDownloadPaymentRecords = function (year, _options) {
        var result = this.api.ableToDownloadPaymentRecords(year, _options);
        return result.toPromise();
    };
    PromiseRevenuesApi.prototype.downloadPaymentRecords = function (year, _options) {
        var result = this.api.downloadPaymentRecords(year, _options);
        return result.toPromise();
    };
    PromiseRevenuesApi.prototype.downloadRevenue = function (month, year, _options) {
        var result = this.api.downloadRevenue(month, year, _options);
        return result.toPromise();
    };
    PromiseRevenuesApi.prototype.getRevenue = function (month, year, _options) {
        var result = this.api.getRevenue(month, year, _options);
        return result.toPromise();
    };
    PromiseRevenuesApi.prototype.getRevenues = function (year, _options) {
        var result = this.api.getRevenues(year, _options);
        return result.toPromise();
    };
    return PromiseRevenuesApi;
}());
exports.PromiseRevenuesApi = PromiseRevenuesApi;
var ObservableAPI_12 = require("./ObservableAPI");
var PromiseSnsLinkagesApi = (function () {
    function PromiseSnsLinkagesApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_12.ObservableSnsLinkagesApi(configuration, requestFactory, responseProcessor);
    }
    PromiseSnsLinkagesApi.prototype.instagramGraphAuth = function (_options) {
        var result = this.api.instagramGraphAuth(_options);
        return result.toPromise();
    };
    return PromiseSnsLinkagesApi;
}());
exports.PromiseSnsLinkagesApi = PromiseSnsLinkagesApi;
var ObservableAPI_13 = require("./ObservableAPI");
var PromiseTermsApi = (function () {
    function PromiseTermsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_13.ObservableTermsApi(configuration, requestFactory, responseProcessor);
    }
    PromiseTermsApi.prototype.agreeToTerms = function (inlineObject7, _options) {
        var result = this.api.agreeToTerms(inlineObject7, _options);
        return result.toPromise();
    };
    PromiseTermsApi.prototype.showTerms = function (category, _options) {
        var result = this.api.showTerms(category, _options);
        return result.toPromise();
    };
    return PromiseTermsApi;
}());
exports.PromiseTermsApi = PromiseTermsApi;
//# sourceMappingURL=PromiseAPI.js.map